import { Component } from '@theme/component';

class ZoqPromoVideo extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.frame = this.querySelector('iframe[data-src]');
    if (!this.frame || this.frame.src) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData) return;
    this.abortController = new AbortController();
    const load = () => {
      this.observer?.disconnect();
      this.frame.addEventListener('load', () => {
        this.revealTimer = window.setTimeout(() => {
          this.frame.parentElement?.classList.add('is-on');
        }, 1500);
      }, { once: true, signal: this.abortController.signal });
      this.frame.src = this.frame.dataset.src;
    };
    if (!('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) load();
    }, { rootMargin: '0px', threshold: 0.1 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.observer?.disconnect();
    this.abortController?.abort();
    window.clearTimeout(this.revealTimer);
  }
}

if (!customElements.get('zoq-promo-video')) customElements.define('zoq-promo-video', ZoqPromoVideo);
